import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';

import { CoverageTab, EnrollReason } from 'src/app/models/coverage';
import { FormValidationService } from 'src/app/services/form-validation.service';

@Component({
    selector: 'mwp-benefit-enrollment-wizard-coverage-enrollment-reason',
    templateUrl: './enrollment-reason.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EnrollmentReasonComponent implements OnInit {
    @Input() public coverageFormGroup: FormGroup;
    @Input() public coverageTab: CoverageTab;

    public requireAdditionalText: boolean;
    public additionalText: string;

    ngOnInit() {
        this.coverageFormGroup.get('enrollReasonID').setValidators([Validators.required, FormValidationService.validDropdown('Enroll Reason')]);
    }

    public reasonChanged(reason: EnrollReason) {
        const l_AdditionalReason = this.coverageFormGroup.get('enrollReasonAdditional');
        
        this.requireAdditionalText = reason.requireAdditionalText

        l_AdditionalReason.setValue(null);
        if (this.requireAdditionalText) {
            this.additionalText = reason.additionalTextPrompt;
            l_AdditionalReason.setValidators(Validators.required);
        } else {
            l_AdditionalReason.clearValidators();
        }

        l_AdditionalReason.updateValueAndValidity();
    }
}